import { render } from "./Big2ChartsPage.vue?vue&type=template&id=a7c68d68&scoped=true"
import script from "./Big2ChartsPage.vue?vue&type=script&lang=js"
export * from "./Big2ChartsPage.vue?vue&type=script&lang=js"

import "./Big2ChartsPage.vue?vue&type=style&index=0&id=a7c68d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c68d68"]])

export default __exports__